import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const h2 = { fontSize: 'var(--text-lg)', fontWeight: 700, marginTop: '2rem', marginBottom: '0.75rem' };
const p = { color: 'var(--ink)', lineHeight: 1.7, marginBottom: '1rem' };
const ul = { color: 'var(--ink)', lineHeight: 1.7, marginBottom: '1rem', paddingLeft: '1.25rem' };

export default function Privacy() {
  return (
    <div className="page">
      <Navbar />
      <div className="container" style={{ padding: '2.5rem 1rem', maxWidth: 760 }}>
        <h1 style={{ fontSize: 'var(--text-2xl)', fontWeight: 800, marginBottom: '0.5rem' }}>Privacy Policy</h1>
        <p style={{ color: 'var(--ink-muted)', marginBottom: '1.5rem' }}>Last updated: July 16, 2026</p>

        <div className="alert alert-info">
          This is placeholder legal text for demo purposes and has not been reviewed by an attorney.
          Replace it with a policy prepared for your jurisdiction before launch.
        </div>

        <p style={p}>
          Blue Signal LLC ("ShareTime," "we," "us," or "our") operates the ShareTime marketplace, which
          connects timeshare owners with travelers looking to rent or buy unused weeks. This Privacy
          Policy explains what information we collect, how we use it, and the choices you have.
        </p>

        <h2 style={h2}>Information We Collect</h2>
        <p style={p}>We collect the following categories of information:</p>
        <ul style={ul}>
          <li><strong>Account information</strong> — name, email address, and password when you register as a buyer or owner.</li>
          <li><strong>Listing and booking information</strong> — property, unit, and stay details you submit when creating a listing, and reservation details when you book or purchase a stay.</li>
          <li><strong>Payment information</strong> — processed by our payment provider, Stripe. ShareTime does not store your full card number; Stripe shares limited transaction details with us (such as amount and status) to fulfill your booking.</li>
          <li><strong>Location and search data</strong> — the resort, address, or map area you search for, and approximate location derived from your search terms or IP address, used to show relevant properties and availability.</li>
          <li><strong>Usage data</strong> — pages viewed, listings favorited, and recently viewed properties, stored locally in your browser and/or associated with your account to improve your experience.</li>
          <li><strong>Communications</strong> — messages you send through our on-platform messaging system, and correspondence with our support team.</li>
        </ul>

        <h2 style={h2}>How We Use Information</h2>
        <ul style={ul}>
          <li>To create and maintain your account and authenticate you when you log in.</li>
          <li>To operate the marketplace — publishing listings, processing bookings and offers, and facilitating messages between buyers and owners.</li>
          <li>To process payments and payouts through Stripe.</li>
          <li>To send transactional emails, such as booking confirmations, price alerts, and new-message notifications.</li>
          <li>To improve and analyze use of our site using tools such as Google Analytics.</li>
          <li>To detect, prevent, and address fraud, abuse, or security issues.</li>
        </ul>

        <h2 style={h2}>How We Share Information</h2>
        <p style={p}>We do not sell your personal information. We share information only as needed to operate the service:</p>
        <ul style={ul}>
          <li>With the other party to a booking or message thread (for example, an owner sees the name and contact details needed to authorize a guest at the resort).</li>
          <li>With service providers who help us operate ShareTime, including Stripe (payments), Amazon Web Services (photo storage), SendGrid (email delivery), and Google (maps, place search, and analytics).</li>
          <li>When required by law, or to protect the rights, property, or safety of ShareTime, our users, or the public.</li>
        </ul>

        <h2 style={h2}>Cookies and Local Storage</h2>
        <p style={p}>
          We use your browser's local storage to keep you signed in and to remember recently viewed
          properties. We use analytics cookies/identifiers (via Google Analytics) to understand how
          visitors use the site. You can clear these at any time through your browser settings.
        </p>

        <h2 style={h2}>Your Choices</h2>
        <ul style={ul}>
          <li>You can update your account information at any time from your dashboard.</li>
          <li>You can remove a saved property or price alert at any time.</li>
          <li>You can request that we delete your account and associated personal data by contacting us below, subject to records we're required to keep for legal, tax, or accounting purposes.</li>
        </ul>

        <h2 style={h2}>Data Retention</h2>
        <p style={p}>
          We retain account, listing, and transaction information for as long as your account is active
          and as needed to comply with our legal obligations, resolve disputes, and enforce our agreements.
        </p>

        <h2 style={h2}>Children's Privacy</h2>
        <p style={p}>
          ShareTime is not directed to children under 18, and we do not knowingly collect personal
          information from children.
        </p>

        <h2 style={h2}>Changes to This Policy</h2>
        <p style={p}>
          We may update this Privacy Policy from time to time. If we make material changes, we will
          update the "Last updated" date above and, where appropriate, notify you.
        </p>

        <h2 style={h2}>Contact Us</h2>
        <p style={p}>
          Questions about this policy can be sent to <a href="mailto:bluesignalllc@gmail.com">bluesignalllc@gmail.com</a>.
        </p>
      </div>
      <Footer />
    </div>
  );
}
